import type { OrderActionKind } from '@/api/orders';

/**
 * What each agent→Matt action kind IS — the chip and its one-line tooltip.
 * A kind, not a state: every kind renders as a neutral pill (lib/status.ts).
 */
export const ACTION_KIND_META: Record<OrderActionKind, { label: string; hint: string }> = {
  decision: { label: 'decision', hint: 'A judgement call for a person, not the run.' },
  portal_pull: { label: 'portal pull', hint: 'A document behind a login the run cannot pass.' },
  payment: { label: 'payment', hint: 'Money moves; never automated.' },
  physical_check: { label: 'physical', hint: 'Something to verify in the building.' },
  vendor_ask: { label: 'vendor ask', hint: 'A conversation with the vendor or rep.' },
  catalog_fix: { label: 'catalog fix', hint: 'A correction in the acot backend.' },
  submit: { label: 'submit', hint: 'Built and validated; waiting only on the submit.' },
  other: { label: 'other', hint: 'Does not fit the other kinds.' },
};
